import React, { Dispatch, SetStateAction } from 'react';
import { Dropdown } from 'react-bootstrap';

import { StateLanguage } from '../../languages/config/StateLanguage';
import { Currency } from '../../models/currency.model';
import { legendValid } from '../../utils/legend.data.util';
import { currencyList, currencyValue } from '../../libraries/currency.library';
import { prefixLegend } from '../../scripts/name.legend.script';
import { formatCurrency } from '../../scripts/format.value.script';

import AppLegend from './Legend';

export interface AppInputCurrencyProps {
  component?: string,
  currency: {value: string, valid: boolean, object: any},
  setCurrency: Dispatch<SetStateAction<{value: string, valid: boolean, object: any}>>
};

const AppInputCurrency: React.FunctionComponent<AppInputCurrencyProps> = ({component, currency, setCurrency}) => {
  const {lang} = StateLanguage()

  const handleChangeCurrency = (item: Currency) => {
    setCurrency({value: item.code, valid: true, object: item})
    legendValid(`${prefixLegend(component)}legend-currency-required`)
  }

  return (
    <>
      <Dropdown>
        <Dropdown.Toggle variant="select2 select2-container select2-container--bootstrap5 select2-container--below select2-container--focus select2-container--open w-100 p-0">
          <span className="selection">
            <span className="select2-selection select2-selection--single form-select">
              <span className="select2-selection__rendered" role="textbox">
                {currency.valid && currency.value.length > 0 ? currencyValue(lang.code, currency.value) : lang.labels.selectOption}
              </span>
            </span>
          </span>
        </Dropdown.Toggle>
        <Dropdown.Menu variant="select2-container select2-container--bootstrap5 select2-container--open w-100">
          <span className="select2-dropdown select2-dropdown--below">
            <span className="select2-results">
              <ul className="select2-results__options" role="listbox">
                { currencyList(lang.code).map (( (item, index) => { return (
                  <li key={index} className={`select2-results__option select2-results__option--selectable ${item.code === currency.value && "select2-results__option--selected"}`} role="option" aria-selected={item.code === currency.value}>
                    <Dropdown.Item bsPrefix="select2-results__option__text" onClick={() => handleChangeCurrency(item)}>{formatCurrency(item)}</Dropdown.Item>
                  </li>
                )}))}
              </ul>
            </span>
          </span>
        </Dropdown.Menu>
      </Dropdown>
      <AppLegend component={component} attribute={{check: currency.valid, name: "currency", index: null, sub_index: null}} container={{valid: false, required: true, identical: false, exists: false}}></AppLegend>
    </>
  )
}

export default AppInputCurrency;
